import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import request from "../../Apis/request";
import { BaseURL, uniqueToken, GpsBaseURL, Role } from "../../api/DataApis";
import axios from "axios";
import Select from 'react-select';


function Add() {
  document.title = "Manual Orders | Add";
  let navigate = useNavigate();


  // State variables
  const [Name, setName] = useState("");
  const [selectedStatusType, setSelectedStatusType] = useState("");
  const [Mobile, setMobile] = useState("");
  const [Email, setEmail] = useState([]);
  const [VehicleNumber, setVehicleNumber] = useState([]);
  const [selectedParent, setselectedParent] = useState([]);
  const [userType, setUserType] = useState([]);
  const [LongitudePoints, setLongitudePoints] = useState("");
  const [Address, setAddress] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState('');
  const [selectedState, setSelectedState] = useState('');
  const [selectedCity, setSelectedCity] = useState('');
  const [selectdStation, setselectedstation] =  useState('');
  const [StationData, setStationData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [VendorAmount, setVendorAmount] = useState('');
  const [CorporateData, setCorporateData] = useState([]);
  const [loadings, setLoadings] = useState(false);
  const [BCCorporateID, setBCCorporateID] = useState(null);
  const [companies, setCompanies] = useState([]);
  const [selectedCorporate, setSelectedCorporate] = useState("");
  const [bcorporateName, setbcorporateName] = useState("");
  const [DistrictName, setDistrictName] = useState("");
  const [PinCode, setPincode] = useState("");
  const [bcAgentID, setbcAgentID] = useState("");
  const [ProductsData, setproductsData] =  useState([]);
  const [selectedProduct, setselectedProduct] =  useState({});
  const [SelectedProductType, setSelectedProductType] = useState("");
  const [ComboProductsData, setComboProductsData] = useState([]);
  const [SelectedComboItems, setselectedComboItems] = useState({});
 const [totalAmount, setTotalAmount] = useState("");

    

const handlevendorAmount = (e) => {
  setVendorAmount(e.target.value);
}
const handleBCCorporateName  = (e) => {
  setbcorporateName(e.target.value);
}
const handlePinCode = (e) => {
  setPincode(e.target.value);
}
const handleDistrictName = (e) => {
  setDistrictName(e.target.value);
}
const handlebcAgentID = (e) => {
  setbcAgentID(e.target.value);
}

const corporateOptions = CorporateData?.map(corporate => ({
  value: corporate._id,
  label: `${corporate.corporate_name} (${corporate?.email})`,
  _id: corporate._id,
}));


useEffect(() => {
    const fetchCompanies = async () => {
        try {
          const res = await axios.get(`${GpsBaseURL}/company`,
          {
            headers: {
              Authorization: `Bearer ${uniqueToken}`,
              // 'Content-Type' is automatically set by axios when using FormData
            },
          });
          const options = res.data?.data?.map((item) => ({
            value: item._id,
            label: item.company_name,
          }));
          setCompanies(options);
        } catch (error) {
          console.error("Error fetching companies:", error);
        }
    };

    fetchCompanies();
}, []);

const handleCountryChange = (selectedOption) => {

  if (!selectedOption) {
    setSelectedCountry("");
    setSelectedState("");
  } else {
    // Update selectedCountry with the chosen option
    setSelectedCountry({ _id: selectedOption._id, id: selectedOption.value });
    setSelectedState(""); // Reset state when a new country is selected
  }
};


  
const handleStateChange = (selectedOption) => {
  if (selectedOption) {
    // Set the selected state if an option is chosen
    setSelectedState({ _id: selectedOption._id, id: selectedOption.value });
  } else {

    setSelectedState("");
  }
};


const handleCityChange = (selectedOption) => {
  setSelectedCity(selectedOption ? selectedOption.value : "");
};
const handlecorporateChange = (selectedOptions) => {
  console.log("selectedOptions", selectedOptions);
 setSelectedCorporate(selectedOptions);
}
const handleProductChange = (selectedOption) => {
  console.log("Selected Product:", selectedOption);
  const selectedProductData = ProductsData.find(product => product._id === selectedOption?.value);
  setselectedProduct(selectedProductData);  // Store full product details
};

const handleComboProductChange = (selectedOptions) => {
  console.log("Selected Product:", selectedOptions);
   const selectedComboProd = selectedProduct?.comboItems.find(product => product.product_id?._id === selectedOptions?.value)
  setselectedComboItems(selectedComboProd);  // Store full product details

}
 
   const fetchCorporate = async () => {
    setLoadings(true);
    
    // Base API URL
    let apiEndpoint = decodeURIComponent(`${GpsBaseURL}/corporate`);
   
    
 try {
      const response = await axios.get(apiEndpoint, {
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          Authorization: `Bearer ${uniqueToken}`, // Replace with actual token if needed
        },
      });
  
      console.log("response", response);
  
      setCorporateData(response.data?.data);
    // Assuming API returns totalCount for pagination
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setLoadings(false);
    }
  };
  
  // Re-fetch users whenever searchTerm changes
  useEffect(() => {
    fetchCorporate();
  }, []);

 

  const countryOptions = countries.map(country => ({
    value: country.id,
    label: country.name,
    _id: country._id,
  }));

  const stateOptions = states.map((state) => ({
    value: state.id,
    label: state.name,
    _id: state._id
  }));

  const cityOptions = cities.map((city) => ({
    value: city._id,
    label: city.name,
  }));

  const ProductOptions = ProductsData?.map((data) => ({
    value: data?._id,
    label: data?.title,
  }));
  const ComboProductsOptions = selectedProduct?.comboItems?.map((data) => ({
    value: data?.product_id?._id,
    label: data?.product_id?.title,
  }));

  const handleName = (e) => setName(e.target.value);
  const handleFileChange = (e) => setSelectedFile(e.target.files[0]);
  const handleAddressChange = (e) => setAddress(e.target.value);
  const handleMobileChange = (e) => setMobile(e.target.value);
  const handleUserTypeChange = (e) => setUserType(e.target.value);
  const handleStatusType = (e) => setSelectedStatusType(e.target.value);
 

  const handleEmailChange = (e) => setEmail(e.target.value);
  console.log("ProductOptions", ProductOptions);

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await axios.get(`${GpsBaseURL}/settings/countries`, {
          headers: {
            Authorization: `Bearer ${uniqueToken}`,
          },
        });
        setCountries(response.data.data);
      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    };

    fetchCountries();
  }, []);

  useEffect(() => {
    if (SelectedProductType) {
      const fetchProducts = async () => {
        try {
          const response = await axios.get(`${GpsBaseURL}/product?corporate_id=${selectedCorporate?._id}&isCombo=${SelectedProductType}`, {
            headers: {
              Authorization: `Bearer ${uniqueToken}`,
            },
          });
          console.log("responseeeeee", response);
           setproductsData(response?.data?.data || [] );
          
        } catch (error) {
          console.error("Error fetching products:", error);
        }
      };
  
      fetchProducts(); // ✅ Now it is inside the if condition
    }
  }, [selectedCorporate, SelectedProductType]); // ✅ Dependency added
  

  useEffect(() => {
    if (selectedCountry.id) {
      const fetchStates = async () => {
        try {
          const response = await axios.get(`${GpsBaseURL}/settings/states/${selectedCountry.id}`, {
            headers: {
              Authorization: `Bearer ${uniqueToken}`,
            },
          });
          setStates(response.data.data.data);
          setCities([]);
        } catch (error) {
          console.error("Error fetching states:", error);
        }
      };

      fetchStates();
    }
  }, [selectedCountry.id]);
  console.log("selectedState.id", selectedState.id);

  const fetchCities = async () => {
    if (selectedState.id) {
      try {
        const response = await axios.get(`${GpsBaseURL}/settings/cities/${selectedState.id}`, {
          headers: {
            Authorization: `Bearer ${uniqueToken}`,
          },
        });
        console.log("Cities API Response:", response.data); 
        if (response.data && response.data.data) {
          setCities(response.data.data.data);
        } else {
          console.warn("No cities data found in response:", response);
          setCities([]); // Clear the cities if response is empty
        }
      } catch (error) {
        console.error("Error fetching cities:", error);
        setCities([]); // Clear the cities in case of error
      }
    }
  };
  useEffect(() => {
    fetchCities(); // Ensure this function is called when selectedState.id changes
  }, [selectedState.id]);





  // Function to handle the update request
  const AddUser = async () => {
    // Show loader before API call
    Swal.fire({
      title: "Adding User...",
      text: "Please wait",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
  
    if (!selectedCorporate && Role === "false") {
      Swal.close(); // Close loader before error
      Swal.fire({
        icon: "error",
        title: "Validation Error",
        text: "Please select a Corporate before proceeding.",
      });
      return;
    }
  const formData =
    // Create a new FormData object
    {
      "name": Name,
      "address": Address,
      "mobile": Mobile,
      "email": Email,
      "pin_code": PinCode,
      "countryId": selectedCountry?._id || null,
      "stateId": selectedState?._id || null,
      "cityId": selectedCity || null,
      "company_id":BCCorporateID || null,
      "bc_corporate_name": bcorporateName || null,
      "district": DistrictName || null,
      // "profile_image": selectedFile || null,
      "bc_agent_id": bcAgentID || null,
      "corporate_id": selectedCorporate?._id || null,
     "items": selectedProduct
  ? [
      {
        "product_id": selectedProduct?._id,
        "quantity": "1",
        "comboItems": [
          {
            "product_id": {
              "_id": SelectedComboItems?.product_id?._id,
              "title": SelectedComboItems?.product_id?.title,
              "price": SelectedComboItems?.product_id?.price,
              "description": SelectedComboItems?.product_id?.description
            }
          }
        ]
      }
    ]
  : null,
  "total_price": totalAmount || null,



    }
      
    try {
      // Make the API request
      let response = await axios.post(`${GpsBaseURL}/order/add-manual-order`, formData, {
        headers: {
          Authorization: `Bearer ${uniqueToken}`,
        },
      });
  
      // Hide the loader
      Swal.close();
  
      if (response.data.statusCode === 200) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "User updated successfully...",
          showConfirmButton: false,
          timer: 1500,
        });
        navigate(`/manualorder`);
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: `Failed to update station. Status: ${response.data.statusCode}`,
        });
      }
    } catch (error) {
      // Hide the loader
      Swal.close();
      console.error("Error in AddUser:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.response?.data?.message || "An unexpected error occurred.",
      });
    }
  };

  const subtotal = (selectedProduct?.price || 0) + (SelectedComboItems?.product_id?.price || 0);
  const discount = (subtotal * ((selectedProduct?.discount ?? 0) / 100)).toFixed(2);
  
  const discountedPrice = subtotal - discount;
  
  // ✅ Correct GST Calculation
  const gst = (discountedPrice * (selectedProduct?.gst ?? 0) / 100).toFixed(2);
  
  // const totalPrice = 
  //  setTotalAmount(parseFloat((discountedPrice + parseFloat(gst)).toFixed(2)));
  useEffect(() => {
    if (!isNaN(discountedPrice) && !isNaN(parseFloat(gst))) {
      const totalPrice = parseFloat((discountedPrice + parseFloat(gst)).toFixed(2));
      setTotalAmount(totalPrice);
    }
  }, [discountedPrice, gst]); // Runs when `discountedPrice` or `gst` changes
  
  
  console.log("subtotal", subtotal);
  // console.log("totalPrice", totalPrice);

  
  
console.log("StationData---", StationData);
console.log("selectedProduct", selectedProduct);
console.log("SelectedProductType", (SelectedProductType));
console.log("ProductsData", ProductsData);
console.log("SelectedComboItems", SelectedComboItems);
  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12">
            <div className="card">
              <h1 className="page-title"></h1>
              <div className="portlet light bordered">
                <div className="portlet-title row">
                  <div className="caption font-dark col-md-10">
                    <h4 className="caption-subject bold uppercase mx-3">
                      Add Manual Order
                    </h4>
                  </div>
                  <div className="caption font-dark col-md-2">
                    <h5 className="caption-subject bold uppercase mx-3">
                      <button className="btn btn-success" onClick={() => navigate(-1)}>
                        Back
                      </button>
                    </h5>
                  </div>
                </div>
                <div className="portlet-body mx-3">
                  <hr />
                  <div className="row">
                    <div className="col-sm-12">
                      <form
                        className="form-horizontal"
                        encType="multipart/form-data"
                        role="form"
                        method="post"
                        style={{ marginTop: "-20px" }}
                      >
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="name_id" className="col-sm-2 control-label">
                            Name
                            </label>
                            <div className="col-sm-6">
                              <input
                                onChange={handleName}
                                value={Name}
                                className="form-control"
                                id="name_id"
                                name="station_name"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>

                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="latitude_id" className="col-sm-2 control-label">
                              Mobile
                            </label>
                            <div className="col-sm-6">
                              <input
                                onChange={handleMobileChange}
                                className="form-control"
                                id="latitude_id"
                                name="latitude"
                                value={Mobile}
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>

                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="longitude_id" className="col-sm-2 control-label">
                              Enter Email
                            </label>
                            <div className="col-sm-6">
                              <input
                              type="email"
                                onChange={handleEmailChange}
                                className="form-control"
                                id="email"
                                name="email"
                                value={Email}
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
<div className="form-group">
                        <div className="row">
                          <label htmlFor="country_id" className="col-sm-2 control-label">Select Country</label>
                          <div className="col-sm-6">
                          <Select
      options={countryOptions}
      onChange={handleCountryChange}
      value={countryOptions.find(option => option.value === selectedCountry.id) || null}
      placeholder="Country"
      
      isClearable
    
      styles={{
        control: (base) => ({
          ...base,
          height: '38px', 
          width: '100%', // Make width responsive
          boxShadow: 'none',
          minWidth: '0', // Ensures it can shrink below 165px if needed
          flex: 1, // Allow select to grow and shrink
        }),
      }}
    />
                          </div>
                          <span className="col-sm-4 control-label"></span>
                        </div>
                      </div>

                      <div className="form-group">
                        <div className="row">
                          <label htmlFor="state_id" className="col-sm-2 control-label">Select State</label>
                          <div className="col-sm-6">
                          <Select
      options={stateOptions}
      onChange={(selectedOption) => {
        if (selectedOption) {
          setSelectedState({ _id: selectedOption._id, id: selectedOption.value });
        } else {
          setSelectedState(""); // Clear selection if option is cleared
        }
      }}
      placeholder="State"
      isClearable
  
      styles={{
        control: (base) => ({
          ...base,
          height: '38px',
          width: '100%', // Make width responsive
          minWidth: '150px',
          flex : 1
        }),
      }}
    />
                          </div>
                          <span className="col-sm-4 control-label"></span>
                        </div>
                      </div>

                      <div className="form-group">
                        <div className="row">
                          <label htmlFor="city_id" className="col-sm-2 control-label">Select City</label>
                          <div className="col-sm-6">
                          <Select
            value={cityOptions.find((option) => option.value === selectedCity) || null}
            onChange={handleCityChange}
            options={cityOptions}
            placeholder="City"
            isClearable
            styles={{
              control: (base) => ({
                ...base,
                height: '38px',
                width: '100%', // Make width responsive
                boxShadow: 'none',
                minWidth: '150px', // Ensures it can shrink below 150px if needed
                flex: 1, // Allow select to grow and shrink
              }),
            }}
          />
                          </div>
                          <span className="col-sm-4 control-label"></span>
                        </div>
                      </div>

                       
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="address_id" className="col-sm-2 control-label">
                              Address
                            </label>
                            <div className="col-sm-6">
                              <textarea
                                onChange={handleAddressChange}
                                value={Address}
                                className="form-control"
                                id="address_id"
                                name="address"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>

                        <div className="form-group row">
                        <label htmlFor="bcCorporateName" className="col-sm-2 col-form-label">
                          Select BC Corporate Name
                        </label>
                        <div className="col-sm-6">
                          <Select
                            id="bcCorporateName"
                            classNamePrefix="react-select"
                            options={companies}
                            value={companies.find((opt) => opt.value === BCCorporateID)}
                            onChange={(selected) => {
                              setBCCorporateID(selected?.value || "");
                            }}
                            placeholder="Select BC Corporate Name"
                            isClearable
                          />
                        </div>
                      </div>
                      
                        {BCCorporateID === "686040c4ec7443e4d4d9348f" && (
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="address_id" className="col-sm-2 control-label">
                            BC Corporate Name
                            </label>
                            <div className="col-sm-6">
                              <input
                                onChange={handleBCCorporateName}
                                value={bcorporateName}
                                className="form-control"
                                id="address_id"
                                name="address"
                                placeholder="Enter BC Corporate Name"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        )}

                        {/* <div className="form-group">
                          <div className="row">
                            <label htmlFor="address_id" className="col-sm-2 control-label">
                            BC Corporate Name
                            </label>
                            <div className="col-sm-6">
                              <input
                                onChange={handleBCCorporateName}
                                value={bcorporateName}
                                className="form-control"
                                id="address_id"
                                name="address"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div> */}

                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="address_id" className="col-sm-2 control-label">
                            BC Agent ID
                            </label>
                            <div className="col-sm-6">
                              <input
                                onChange={handlebcAgentID}
                                value={bcAgentID}
                                className="form-control"
                                id="address_id"
                                name="address"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>

                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="address_id" className="col-sm-2 control-label">
                            District
                            </label>
                            <div className="col-sm-6">
                              <input
                                onChange={handleDistrictName}
                                value={DistrictName}
                                className="form-control"
                                id="address_id"
                                name="address"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>

                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="address_id" className="col-sm-2 control-label">
                            Pin Code
                            </label>
                            <div className="col-sm-6">
                              <input
                                onChange={handlePinCode}
                                value={PinCode}
                                className="form-control"
                                id="address_id"
                                name="address"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>

                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="file_id" className="col-sm-2 control-label">
                              Image
                            </label>
                            <div className="col-sm-6">
                              <input
                                type="file"
                                onChange={handleFileChange}
                                className="form-control"
                                id="file_id"
                                name="user_image"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>

                     
                      {Role ==="false" && (
                        <>
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="statusType" className="col-sm-2 control-label">
                              Select Corporate
                            </label>
                            <div className="col-sm-6">
                            <Select
  options={corporateOptions}
  onChange={handlecorporateChange}
  value={selectedCorporate ? corporateOptions?.find(option => option.value === selectedCorporate.id) : null}
  placeholder="Select Corporate"
  isClearable
/>
</div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        </>
                        )}
                        {selectedCorporate && (
                       <div className="form-group">
                       <div className="row">
                         <label htmlFor="statusType" className="col-sm-2 control-label">
                           Select Type
                         </label>
                         <div className="col-sm-6">
                             <select className = "form-select" onChange= {(e) => setSelectedProductType(e.target.value) || setselectedProduct("") || setTotalAmount === ""}>
                              <option>Select Type</option> 
                              <option value = "false">Product</option>
                              <option value = "true">Combo Product</option>
                             </select>

                         </div>
                        
                       </div>
                     </div>
                     
                        )}
                        {SelectedProductType && (
                        
                        <div className="form-group">
  <div className="row">
    <label htmlFor="statusType" className="col-sm-2 control-label">
      Select Product
    </label>
    <div className="col-sm-6">
      <Select
        options={ProductOptions}
        onChange={handleProductChange}
        value={selectedProduct ? ProductOptions?.find(option => option?.value === selectedProduct?.value) : null}
        placeholder="Select Product"
        isClearable
      />
    </div>
    <span className="col-sm-4 control-label"></span>
  </div>
</div>
                      )}

                      {selectedProduct?.comboItems?.length>0 && (
                        <>
                                                <div className="form-group">
  <div className="row">
    <label htmlFor="statusType" className="col-sm-2 control-label">
      Select Combo Product
    </label>
    <div className="col-sm-6">
      <Select
        options={ComboProductsOptions}
        onChange={handleComboProductChange}
        // value={selectedProduct ? ProductOptions?.find(option => option?.value === selectedProduct?.value) : null}
        placeholder="Select Product"
        isClearable
      />
    </div>
    <span className="col-sm-4 control-label"></span>
  </div>
</div>
                        </>

)}
{selectedProduct?.price >= 0 && (
   <div className="form-group">
                       <div className="row">
                         <label htmlFor="statusType" className="col-sm-2 control-label">
                           Total Price
                         </label>
                         <div className="col-sm-6">
                             <input value ={totalAmount} className = "form-select"  onChange={(e)=> setTotalAmount(e.target.value)}/>
                           </div>
                         </div>
                     </div>
                  )}

              



                        <div className="form-group">
                          <div className="col-sm-offset-2 col-sm-8 add-class">
                            <input
                              type="button"
                              className="btn btn-success"
                              onClick={AddUser}
                              value="Add Order"
                            />
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Add;
